import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

class VideoMessageRecord extends BaseMessageRecord({
  type: "video",

  /** @memberof VideoMessageRecord# */
  altText: "",

  /** @memberof VideoMessageRecord# */
  vidUrl: ""
}) {}

/**
 * Validation
 */

/**
 * @param {VideoMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
VideoMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (message.vidUrl.length <= 0) {
    invalidFields.add("vidUrl");
  }

  return Immutable.List(invalidFields);
};

export default VideoMessageRecord;
